import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener el color principal de una sucursal
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: color (string), isLoading, error }
 */
export const useCategoryColor = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.categoryColor(shopBranchId),
    
    queryFn: async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_CATEGORY_COLOR}/${shopBranchId}`
      );
      return response.data;
    },
    
    enabled: !!shopBranchId,
    
    // Color raramente cambia
    staleTime: staleTimes.static, // 1 hora
    
    cacheTime: 2 * 60 * 60 * 1000, // 2 horas
    
    ...options,
  });
};
